import React, { useEffect } from 'react'
import { Animated, StyleSheet, ViewProps, Platform } from 'react-native'

import { Color, Spacing } from '../../style'
import { Banner, BannerProps, BannerStatus } from '../feedback'

const styles = StyleSheet.create({
  container: {},
  banner: {
    marginTop: Spacing.XS,
    paddingVertical: Spacing.S,
    ...Platform.select({
      native: {
        shadowColor: Color.premiumBlack,
        shadowOpacity: 0.2,
        shadowOffset: { width: 0, height: 6 },
        shadowRadius: 20,
      },
      web: {
        '--opacity': 0.2,
        boxShadow: `0px 6px 20px ${Color.premiumBlack}`,
      },
    }),
  },
})

export type ToastStatus = BannerStatus

export interface ToastInfo extends BannerProps {
  id: number | string
}

interface Props extends ViewProps {
  info: ToastInfo
  onClose?: () => void
}
const ToastMessage = (props: Props) => {
  const { info, onClose, style } = props
  const opacity = React.useRef(new Animated.Value(0)).current

  useEffect(() => {
    show()
  }, [])

  const show = () => {
    Animated.timing(opacity, {
      toValue: 1,
      duration: 300,
      useNativeDriver: false,
    }).start()
  }

  const containerStyle = {
    opacity,
    transform: [
      {
        scale: opacity,
      },
    ],
  }
  return (
    <Animated.View style={[styles.container, containerStyle, style]}>
      <Banner style={styles.banner} onClose={onClose} {...info} closeable={info.closeable !== false} />
    </Animated.View>
  )
}

export default ToastMessage
